import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  message,
  Spin,
} from "antd";
import "./index.css";
import { preChatDefaultForm } from "../../../utils/constants";
import { getWidgetsByPropertyId } from "../../WidgetSettings/APIs/firebaseWidgetSettingsApis";
import {
  getActivitiesBySession,
  getSession,
  getVisitor,
} from "../../../firebase/queries";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import {
  capitalize,
  getDeviceIcon,
  getOSIcon,
  getPlatformIcon,
  parseFirebaseDateTime,
} from "../../../utils/helper";
import MessagesContainer from "../../../components/MessagesContainer";
import "./index.css";
import { jsPDF } from "jspdf";

const { Search } = Input;

const VisitorHistoryDrawer = (props) => {
  const { showDrawer, hideModal, modalData, histories, setDrawerContent } =
    props;
  const [loading, setLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  const [selectedVisitor, setSelectedVisitor] = useState({});
  const [selectedSession, setSelectedSession] = useState({});
  const [preChatFields, setPreChatFields] = useState(preChatDefaultForm);
  const [searchActivities, setSearchActivities] = useState([]);
  const [searchMsg, setSearchMsg] = useState("");
  const [searchValue, setSearchValue] = useState("");

  let pre_chat =
    selectedSession?.pre_chat || !selectedSession?.hasOwnProperty("pre_chat");

  useEffect(() => {
    if (selectedVisitor?.propertyId) fetchWidget();
  }, [selectedVisitor]);

  const fetchWidget = async () => {
    const result = await getWidgetsByPropertyId(selectedVisitor?.propertyId);
    setPreChatFields(result.pre_chat_form_fields);
  };

  useEffect(() => {
    if (modalData?.session && modalData.identifier) {
      setSelectedVisitor({});
      setSelectedSession({});
      setActivities([]);
      const loadData = async () => {
        const { identifier, session } = modalData;
        setLoading(true);
        const visitor = await getVisitor(identifier);
        const sessionGet = await getSession(identifier, session);
        const activities = await getActivitiesBySession(identifier, session);
        setSelectedVisitor(visitor);
        setSelectedSession(sessionGet);
        setActivities(activities?.reverse());
        setLoading(false);
      };

      loadData();
    }
    return () => {
      setSearchMsg("");
    };
  }, [modalData]);

  const onSearch = (value) => {
    setSearchValue(value);
    if (value !== "") {
      let filteredActivities = activities
        ?.filter((item) =>
          item.body.toLowerCase().includes(value.toLowerCase())
        )
        ?.map((item) => item.id);

      setSearchActivities(filteredActivities);
      setSearchMsg(filteredActivities[0]);
    } else {
      setSearchMsg("");
    }
  };

  const handleNext = () => {
    let nextId = searchActivities[searchActivities.indexOf(searchMsg) + 1];
    if (nextId !== undefined) {
      setSearchMsg(nextId);
    } else {
    }
  };
  const handlePrevious = () => {
    let prevId = searchActivities[searchActivities.indexOf(searchMsg) - 1];

    if (prevId !== undefined) {
      setSearchMsg(prevId);
    } else {
    }
  };

  let checkSearchMsg = searchMsg !== "";

  const onNextHistoryClick = (currentId) => {
    const currentIndex = histories?.findIndex(
      (history) => history.id === currentId
    );
    if (currentIndex < histories?.length - 1) {
      let nextElement = histories[currentIndex + 1];
      setDrawerContent(nextElement);
    } else {
      console.log("No more next history.");
    }
  };

  const onPrevHistoryClick = (currentId) => {
    const currentIndex = histories.findIndex(
      (history) => history.id === currentId
    );
    if (currentIndex > 0) {
      let previousElement = histories[currentIndex - 1];
      setDrawerContent(previousElement);
    } else {
      console.log("No more previous history.");
    }
  };

  const compileLocation = (visitor) => {
    const { countryName, stateProv, city } = visitor;
    let location = "";
    if (city) location += `${city}, `;
    if (stateProv) location += `${stateProv}, `;
    if (countryName) location += `${countryName}`;

    return location || "-";
  };

  const exportConversation = () => {
    const data = activities.map((activity) => {
      return {
        time: parseFirebaseDateTime(activity.created_at),
        name: activity.name ? activity.name : "",
        isVisitor: activity.isVisitor,
        body: activity.body,
      };
    });

    const doc = new jsPDF();

    // Add Title
    doc.setFontSize(12);
    doc.text("Conversation", 10, 10);

    let y = 20;

    // Add each activity
    data.forEach((item, index) => {
      if (y > 270) {
        doc.addPage(); // Add new page if content overflows
        y = 10; // Reset Y position
      }

      doc.setFontSize(12);
      doc.text(`Name: ${item.name}`, 10, y);
      y += 10;
      doc.text(`Message: ${item.body}`, 10, y);
      y += 10;
      doc.text(`Time: ${item.time}`, 10, y);
      y += 15; // Add space between entries
    });

    // Save the PDF
    doc.save(
      `${
        selectedVisitor?.name || selectedVisitor?.visitor_default || "Visitor"
      }-conversation.pdf`
    );
  };

  return (
    <Drawer
      title={modalData?.name}
      width={720}
      onClose={hideModal}
      open={showDrawer}
      styles={{
        header: {
          padding: 10,
        },
        body: {
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 5,
          paddingBottom: 5,
        },
      }}
      extra={
        <Space>
          <Button
            onClick={() => onPrevHistoryClick(modalData?.id)}
            icon={<LeftOutlined />}
          ></Button>
          <Button
            onClick={() => onNextHistoryClick(modalData?.id)}
            icon={<RightOutlined />}
          ></Button>
        </Space>
      }
    >
      <Spin spinning={loading}>
        <div className="visitor_info">
          <Row gutter={[8, 0]}>
            {!selectedSession?.hasOwnProperty("pre_chat") && (
              <>
                <Col span={8} className="flex_items_col">
                  <p>First Name: </p>
                  <p>
                    <strong>
                      {selectedVisitor.firstName
                        ? selectedVisitor.firstName
                        : selectedVisitor.name}
                    </strong>
                  </p>
                </Col>
                <Col span={8} className="flex_items_col">
                  <p>Last Name: </p>
                  <p>
                    <strong>{selectedVisitor.lastName ?? "-"}</strong>
                  </p>
                </Col>
                <Col span={8} className="flex_items_col">
                  <p>Email: </p>
                  <p>
                    <strong>{selectedVisitor.email ?? "-"}</strong>
                  </p>
                </Col>
                <Col span={8} className="flex_items_col">
                  <p>Phone: </p>
                  <p>
                    <strong>{selectedVisitor.phone ?? "-"}</strong>
                  </p>
                </Col>
              </>
            )}

            {/* Pre Chat Form Fields */}

            {!pre_chat &&
              modalData?.pre_chat_fields?.map((field, index) => (
                <Col span={8} className="flex_items_col" key={index}>
                  <p>{field?.label}</p>
                  <p>
                    <strong>{field?.value ?? "-"}</strong>
                  </p>
                </Col>
              ))}

            {pre_chat &&
              modalData?.pre_chat_fields?.map((field, index) => (
                <Col span={8} className="flex_items_col" key={index}>
                  <p>{field?.label}</p>
                  <p>
                    <strong>{field?.value ?? "-"}</strong>
                  </p>
                </Col>
              ))}
            <Col span={8} className="flex_items_col">
              <p>IP Address: </p>
              <p>
                <strong>{selectedVisitor.ipAddress ?? "-"}</strong>
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Location: </p>
              <p>
                <strong>{compileLocation(selectedVisitor)}</strong>
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Landing Page: </p>
              <p className="url_resp">
                {selectedSession?.landingPage ? (
                  <a
                    href={selectedSession?.landingPage}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <strong>{selectedSession?.landingPage}</strong>
                  </a>
                ) : null}
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Medium: </p>
              <p>
                <strong>{selectedSession.utmMedium ?? "-"}</strong>
              </p>
            </Col>
            {selectedSession?.fbclid ||
            selectedSession?.gclickid ||
            selectedSession?.msclkid ? (
              <Col span={8} className="flex_items_col">
                <p>
                  {selectedSession?.fbclid
                    ? "fbclid: "
                    : selectedSession?.msclkid
                    ? "msclkid: "
                    : "gclickid: "}
                </p>
                <p className="url_resp">
                  <strong>
                    {selectedSession?.fbclid
                      ? selectedSession?.fbclid
                      : selectedSession?.msclkid
                      ? selectedSession?.msclkid
                      : selectedSession?.gclickid}
                  </strong>
                </p>
              </Col>
            ) : null}
            <Col span={8} className="flex_items_col">
              <p>Campaign: </p>
              <p>
                <strong>{selectedSession.utmCampaign ?? "-"}</strong>
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Source: </p>
              <p>
                <strong>{selectedSession.utmSource ?? "-"}</strong>
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Browser: </p>
              <p>
                <strong title={capitalize(selectedVisitor?.platform)}>
                  {getPlatformIcon(selectedVisitor?.platform) ?? "-"}
                </strong>
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Platform: </p>
              <p>
                <strong title={capitalize(selectedVisitor?.os)}>
                  {getOSIcon(selectedVisitor?.os) ?? "-"}
                </strong>
              </p>
            </Col>
            <Col span={8} className="flex_items_col">
              <p>Device: </p>
              <p>
                <strong title={capitalize(selectedVisitor?.device)}>
                  {getDeviceIcon(selectedVisitor?.device) ?? "-"}
                </strong>
              </p>
            </Col>
          </Row>
        </div>
        <Row>
          <Col sm={10} xs={24}>
            <h3 className="p-color">Transcript</h3>
            <Button onClick={exportConversation}>Export Conversation</Button>
          </Col>
          <Col sm={14} xs={24} className="flex_items">
            <Search
              value={searchValue}
              allowClear
              placeholder="Search messages.. "
              onSearch={onSearch}
              onChange={(e) => setSearchValue(e.target.value)}
              enterButton
            />
            {checkSearchMsg && (
              <div className="count-controls">
                <p className="countMsgs">
                  {searchActivities.indexOf(searchMsg) + 1} /{" "}
                  {searchActivities?.length}
                </p>
                <div className="chevronBtns">
                  <button onClick={handleNext}>
                    <i class="fa-solid fa-chevron-down"></i>
                  </button>
                  <button onClick={handlePrevious}>
                    <i class="fa-solid fa-chevron-up"></i>
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>
        <br />
        <div className="transcript">
          <MessagesContainer
            messages={activities}
            visitor={selectedVisitor}
            searchMsg={searchMsg}
          />
        </div>
      </Spin>
    </Drawer>
  );
};

export default VisitorHistoryDrawer;
